import React, { useState, useEffect } from 'react'
import { getcampaignsByAggregatorIdbyName } from '../../ActionCreator';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import moment from 'moment'
export default function Campaign({handleCustomTab,Data, dateFilterPopup, commonFilter, setDateFilterPopup}) {
    const [loader,setLoader] =useState(false)
    const [enabled, setEnabled] = useState(false);
    const [tableData, settableData] = useState([])

     useEffect(() => {
                if (
                    commonFilter?.fromDate !== dateFilterPopup.from ||
                    commonFilter?.toDate !== dateFilterPopup.to
                ) {
                    setDateFilterPopup((prev) => ({
                        ...prev,
                        from: commonFilter.fromDate,
                        to: commonFilter.toDate
                    }));
                }
                const obj = { start: moment(commonFilter.fromDate).format("DD-MM-YYYY"), end: moment(commonFilter.toDate).format("DD-MM-YYYY") }
                ApiData(obj)
            
            }, [commonFilter])

     const ApiData = (obj) => {
            setLoader(true)
            getcampaignsByAggregatorIdbyName(obj?.start ?? "", obj?.end ?? "", Data?.id ?? "", callback => {
            // getcampaignsByAggregatorIdbyName("01-01-2026", "29-01-2026", "131515588e04477c", callback => {
                setLoader(false)
                settableData(callback?.data ?? [])
            })
        }

    return (
        <>
        {loader ? <Loader /> :""}
            <div className='OverView-Main-Section min-size-marketing-1800'>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="customDash-table" style={{ marginTop: '30px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5>Campaign's List</h5>
                                {/* <button style={{ background: '#035865', color: '#fff', padding: '6px 10px', borderRadius: '4px', marginRight: '10px' }} onClick={()=>handleCustomTab("AddCampaign","")}>Add Campaign</button> */}
                            </div>
                            <div className='main-customized-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Campaign Name</th>
                                            {/* <th>Platform (Icon based)</th> */}
                                            <th>Partner Name</th>
                                            <th>Start Date</th>
                                            <th>Leads</th>
                                            <th>Disbursement</th>
                                            {/* <th>Budget Usage %</th> */}
                                            <th>Status</th>
                                            {/* <th>Pause/Play Campaign</th> */}

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData?.length > 0 ? tableData?.map((val, id) => {
                                                return (
                                                    <tr key={id}>

                                                        <td>{val?.campaignName ?? ""}</td>
                                                        <td>{val?.partnerName ?? ""}</td>
                                                        <td>{val?.startDate ?? ""}</td>
                                                        <td>{val?.totalLeads ?? ""}</td>
                                                        <td>{val?.disbursedLeads ?? ""}</td>
                                                        <td>{val?.status == true ? "Active" : "Inactive" ?? ""}</td>
                                                    </tr>
                                                )
                                            })
                                                : ""}

                                     
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
